import { FC } from 'react';
import { cvaRoot, cvaSup } from './PageTitleStyles';

interface Props {
  text: string;
  small?: string;
}

const PageTitle: FC<Props> = ({ text, small }) => {
  return (
    <h1 className={cvaRoot()}>
      <span dangerouslySetInnerHTML={{ __html: text }}></span>
      {small ? <sup className={cvaSup()}>{small}</sup> : null}
    </h1>
  );
};

export default PageTitle;
